import { registerAPI } from "@/apis/user";
import { Button, Form, Select, Input, message, Card, Switch } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useCompanyList } from "@/hooks/useCompanyList";

const { Option } = Select;

//用户注册（需要管理员权限）
const UserRegister = () => {

    const { t } = useTranslation();

    const { companyList } = useCompanyList();
    useEffect(() => {
        console.log("Company List:", companyList);

    }, [companyList]);

    const [form] = Form.useForm();
    const [address, setAddress] = useState('');
    // 已移除弹窗注册逻辑，直接表单提交

    const [messageApi, contextHolder] = message.useMessage();
    const info = (msg) => {
        messageApi.info(msg);
    };
    const success = (msg) => {
        messageApi.success(msg);
    };
    const error = (msg) => {
        messageApi.error(msg);
    };

    //注册表单提交
    const onRegisterFinish = async (values) => {
        const { username, password, companyId, designer = false, executor = false } = values;
        const data = {
            username,
            password,
            token: '',
            ip: address,
            companyId,
            designer: designer ? 1 : 0,
            executor: executor ? 1 : 0,
        };
        register(data);
    };
    //注册表单提交失败
    const onRegisterFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    //通过接口提交注册表单
    async function register(formData) {

        try {
            const res = await registerAPI(formData)
            info(res.msg)
        } catch (error) {
            console.error("Registration error:", error);
            message.error(
                <>
                    {t('RegistrationFailed')}
                    <br />
                    {t('PleaseTryAgainLater')}
                </>
            );
        }
    }

    return (
        <Card title="用户注册">
            {contextHolder}
            <Form layout='vertical' validateTrigger="onBlur" onFinish={onRegisterFinish} onFinishFailed={onRegisterFinishFailed}>

                <Form.Item
                    label="账号:"
                    name="username"
                    rules={[{
                        required: true,
                        message: 'Please input username'
                    }]}>
                    <Input size="large" />
                </Form.Item>

                <Form.Item
                    name="password"
                    label="密码:"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your password!',
                        },
                        {
                            min: 4,
                            required: true,
                            message: 'Password length needs to be longer than 3!',
                        }
                    ]}
                    hasFeedback
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    name="confirm"
                    label="确认密码:"
                    dependencies={['password']}
                    hasFeedback
                    rules={[
                        {
                            required: true,
                            message: 'Please confirm your password!',
                        },
                        {
                            min: 4,
                            required: true,
                            message: 'Password length needs to be longer than 3!',
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('The new password that you entered do not match!'));
                            },
                        }),
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                {/* 岗位字段已取消 */}

                <Form.Item
                    name="companyId"
                    label="公司:"
                    rules={[{ required: true, message: 'Please select your company!' }]}
                >
                    <Select placeholder="Select your company">
                        {companyList.map((company) => (
                            <Option key={company.id} value={company.id}>
                                {company.companyName || company.name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item name="designer" label="使用地面站" valuePropName="checked" initialValue={false}>
                    <Switch />
                </Form.Item>
                <Form.Item name="executor" label="使用设计软件" valuePropName="checked" initialValue={false}>
                    <Switch />
                </Form.Item>

                <Form.Item
                    wrapperCol={{
                        offset: 8,
                        span: 16,
                    }}
                >
                    <Button style={{}} type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>

            </Form>
        </Card>
    )
}

export default UserRegister;